// DeeplinkRedirect.jsx
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const RedirectHandler = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const deeplink = searchParams.get("deeplink");
    if (deeplink) {
      const decodedLink = decodeURIComponent(deeplink);
      window.location.href = decodedLink;
    }
  }, [searchParams]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Redirecting...</h2>
    </div>
  );
};

export default RedirectHandler;
